import {FullTeamGrid} from './grid/full';
import {LocationTeamGrid} from './grid/location';

export default function init(): void {
	const location = window.location.pathname.match(/^\/team\/location\/([\w_-]+)/)?.[1];
	const grid = location ? new LocationTeamGrid(location) : new FullTeamGrid();
	grid.load();
}
